import {
  graphql,
  PreloadedQuery,
  usePreloadedQuery,
  useQueryLoader,
  useSafeRelay,
} from 'utils/graphClient';
import {
  useItemHandleQuery,
  useItemHandleQuery$variables,
} from './__generated__/useItemHandleQuery.graphql';

export type ItemReference = PreloadedQuery<useItemHandleQuery>;

const itemQuery = graphql`
  query useItemHandleQuery($itemId: ID!) {
    item: node(id: $itemId) {
      __typename
      id
      ...useItemHandleFragment
    }
  }
`;

export const useItemHandleLoader = () => {
  return useQueryLoader<useItemHandleQuery>(itemQuery);
};

export const usePreloadedItemHandle = (searchRef: ItemReference) => {
  return usePreloadedQuery<useItemHandleQuery>(itemQuery, searchRef);
};

export const useLazyLoadItemHandleQuery = (
  props: useItemHandleQuery$variables,
) => {
  const { useLazyLoadQuery } = useSafeRelay();
  return useLazyLoadQuery<useItemHandleQuery>(itemQuery, props);
};
